module.exports = __webpack_public_path__ + "img/dreamcatcher.0153ff41.png";